import { configureStore }   from '@reduxjs/toolkit'
import notificationReducer  from './notificationSlice'
import teleconsultReducer   from './teleconsultSlice'
import ondemandReducer   from './ondemandSlice'

export const store = configureStore({
  reducer: {
    theNotification: notificationReducer,
    theTeleconsult: teleconsultReducer,
    theTeleconsultOnDemand: ondemandReducer,
  },
})